// store/menuSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  globalSearchOpen: false,
};

const searchSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openGlobalSearch: (state) => {
      state.globalSearchOpen = true;
    },
    closeGlobalSearch: (state) => {
      state.globalSearchOpen = false;
    },
    toggleGlobalSearch: (state) => {
      state.globalSearchOpen = !state.globalSearchOpen;
    },
  },
});

export const { openGlobalSearch, closeGlobalSearch, toggleGlobalSearch } = searchSlice.actions;
export default searchSlice.reducer;
